import React from 'react';
import { Sparkles } from 'lucide-react';
import './Hero.css';

const Hero = () => {
  return (
    <section id="accueil" className="hero">
      <div className="container">
        <div className="theme-2026">
          <div className="sparkle-icon">
            <Sparkles size={48} />
          </div>
          <h1>2026</h1>
          <p>L'année de l'Abondance Surnaturelle</p>
          <p>Year of Supernatural Abundance</p>
          <p>Jahr der Übernatürlichen Überfülle</p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
